import { Avatar, Box } from "@mui/material"
import { formatPhoneNumber, prefixDecoder } from "../logic/utils"
import { DataGrid } from "@mui/x-data-grid"
import { Button } from "react-bootstrap"
import { Link } from "react-router-dom"


const DirectoryTable = ({ data, height, loading }) => {

    // data.forEach(safeAP=>{
    //     console.log(safeAP.id)
    // })
    // console.log(data.ma)
    const columns = [
        {
            field: "profileImage",
            headerName: "",
            renderCell: (params) => {
                
                var src=''
                if (params.row.formData.img&&params.row.formData.img.length>=1){
                    src=params.row.formData.img[0].content
                }
                return <Avatar
                    alt={`${params.row.formData.firstName || ''} ${params.row.formData.lastName || ''}`}
                    src={src}
                    sx={{width:56, height:56, marginTop:"10px", marginBottom:"10px"}}
                />
            },
            width: 75
        },
        {
            field: 'fullName',
            headerName: 'Full name',
            valueGetter: (params) => `${prefixDecoder(params.row.formData.prefix)}${params.row.formData.firstName || ''} ${params.row.formData.lastName || ''}`,
            flex: 1
        },
        {
            field: 'email',
            headerName: 'Email',
            valueGetter: (params) => `${params.row.formData.email || ''}`,
            flex: 1
        },
        {
            field: 'number',
            headerName: 'Phone number',
            valueGetter: (params) => `${formatPhoneNumber(params.row.formData.phone) || ''}`,
            flex: 1
        },
        {
            field: "location",
            headerName: "Location",
            valueGetter: (params) => `${params.row.formData.city || ''}, ${params.row.formData.stateProvince || ''}, ${params.row.formData.country || ''}`,
            flex: 1
        },
        {
            field: "view",
            headerName: "",
            sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation();
                    console.log(params.row.id)

                }


                // return (
                //     <Button style={{ backgroundColor: "#14417C" }} onClick={onClick}>View</Button>
                // )
                return (<Link to={`/directory/${params.row.id}`}>
                    <Button style={{ backgroundColor: "#14417C" }} onClick={onClick}>View</Button>
                </Link>)
            }
        }

    ]

    return (
        <Box sx={{ width: "100%", height: height * 0.7 }}>
            <DataGrid
                columns={columns}
                rows={data}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
                pageSizeOptions={[10]}
                disableRowSelectionOnClick
                disableColumnMenu
                getRowHeight={()=>'auto'}
                sx={{'& .MuiDataGrid-columnHeaders':{
                    backgroundColor:"#E2E8F0"
                }}}
                loading={loading}
            />
        </Box>
    )
}

export default DirectoryTable


